import PaceMakerImpiantoEdit from "./components/PaceMakerImpiantoEdit.vue";
import PaceMakerImpiantoView from "./components/PaceMakerImpiantoView.vue";
import PaceMakerImpiantoList from "./components/PaceMakerImpiantoList.vue";

export default {
    PaceMakerImpiantoEdit,
    PaceMakerImpiantoView,
    PaceMakerImpiantoList,
};
